module.exports = __webpack_public_path__ + "img/mb-who-are-we-banner.43b2f22c.png";